import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate } from 'cpool-tables/backend-resolvers';

import { type Tanstack, useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

type ResubmissionRange = {
    /** Inclusive lower bound for the resubmission timestamp. */
    start: Date;
    /**
     * Exclusive upper bound. Omit it to let the backend bound the range at the current time, i.e. to
     * fetch only the resubmissions that are already due (what the notification bell shows). The
     * dashboard passes the end of the day so it also lists resubmissions still scheduled for later.
     */
    end?: Date;
};

type ResubmissionQueryOptions = Tanstack<typeof schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate>;

export const useResubmissions = ({ end, start }: ResubmissionRange, tanstack?: ResubmissionQueryOptions) => {
    // shared by every range — a notifications push sets it so all ranges wait for the triggering event
    const queryKey = queryKeys.getResubmissionLoanRequestsByDate();
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getResubmissionLoanRequestsByDate,
        schema: schemaLoanRequestResolver_GetResubmissionLoanRequestsByDate,
        searchParams: { end, position: queryPosition, start },
        tanstack: {
            placeholderData: keepPreviousData,
            ...tanstack,
        },
    });
};
